import { render, staticRenderFns } from "./hand_raise_lead_button.vue?vue&type=template&id=54d0c8b9"
import script from "./hand_raise_lead_button.vue?vue&type=script&lang=js"
export * from "./hand_raise_lead_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports